import React from "react";
import "./Career.css";
import { jobs } from "../constant/job";
import MediaCarousel from "./MediaCarousel";
import CeoPosts from "./CeoPosts";

const lifeAtTedekstraMedia = [
  // 1. Videos from LinkedIn
  {
    type: "video",
    src: "/videos/tedekstra-life-1.mp4",
    title: "Life at Tedekstra - Employee Experience & Work Tribe",
    caption: "Life at Tedekstra - From our Project Manager - Puja Kesari",
  },
  {
    type: "video",
    src: "/videos/tedekstra-life-2.mp4",
    title: "Life at Tedekstra - Work Culture & Digital Innovation",
    caption: "Life at Tedekstra - From our Project Manager - Sathish Kumaraan",
  },
  {
    type: "video",
    src: "/videos/tedekstra-life-3.mp4",
    title: "Life at Tedekstra - Team Energy & Milestones",
    caption: "Life at Tedekstra - From our Sr. Software Developer - Raghav Khanna",
  },
  // 2. Photos & Media
  { type: "image", src: "/images/life1.png", alt: "Life at Tedekstra - Culture & Work Tribe" },
  { type: "image", src: "/images/life2.png", alt: "Life at Tedekstra - Team Collaboration" },
  { type: "image", src: "/images/life3.png", alt: "Life at Tedekstra - Innovation & Tech" },
  { type: "image", src: "/images/life_at_tedekstra-4.png", alt: "Life at Tedekstra - Work Environment" },
  // { type: "image", src: "/images/life5.png", alt: "Life at Tedekstra - Team Moments" },
  { type: "image", src: "/images/life6.png", alt: "Life at Tedekstra - Celebrations & Milestones" },
  { type: "image", src: "/images/life7.png", alt: "Life at Tedekstra - Knowledge Sharing" },
  { type: "image", src: "/images/life8.png", alt: "Life at Tedekstra - Community & Fun" },
];

const Career = () => {
  const featuredJob = jobs.find((job) => job.isFeatured) || jobs[0];
  const listJobs = jobs.filter((job) => job !== featuredJob);

  return (
    <>
      <section className="py-5" data-aos="fade-up">
        <div className="container">
          <div className="card bg-light">
            <section data-aos="fade-up">
              <div className="card career-hero-section">
                <div className="career-hero-heading">
                  <h1>Together, we can make a difference.</h1>
                  <p className="career-hero-heading-text">
                    Be a part of our work tribe
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </section>

      <section className="py-5" data-aos="fade-up">
        <div className="container">
          <div className="card bg-light card-career" style={{ padding: "7% 10%" }}>
            <img
              src="./images/ellipse.png"
              className="career-overlay-image"
              height="40"
              alt=""
            />
            <p className="text-white mb-4 matter-head">
              What matters to us & will make a difference to you
            </p>
            <div className="row text-white">
              <div className="col-md-3">
                <div>
                  <img src="./images/cube3.png" alt="" />
                  <p className="matter-card-head mt-4">Inclusive Culture</p>
                  <p className="matter-card-body">
                    We have a 50:50 male:female ratio and we encourage
                    inclusiveness and one team culture.
                  </p>
                </div>
                <div className="mt-4">
                  <img src="./images/cube.png" alt="" />
                  <p className="matter-card-head mt-4">Collaborative</p>
                  <p className="matter-card-body">
                    We are all about collaboration. We do things together.
                  </p>
                </div>
              </div>
              <div className="col-md-3">
                <div>
                  <img src="./images/cube2.png" alt="" />
                  <p className="matter-card-head mt-4">Work Life Balance</p>
                  <p className="matter-card-body">
                    Working hard is important, but taking time off to relax and
                    recharge is just as essential.
                  </p>
                </div>
                <div className="mt-4">
                  <img src="./images/cube4.png" alt="" />
                  <p className="matter-card-head mt-4">
                    Opportunity to Innovate
                  </p>
                  <p className="matter-card-body">
                    Innovation isn't just about ideas—it's about making them
                    happen.
                  </p>
                </div>
              </div>
              <div className="col-md-6 d-flex align-items-center justify-content-center">
                <img
                  src="./images/career-group.png"
                  className="img-fluid"
                  alt=""
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-5 bg-white" data-aos="fade-up">
        <div className="container">
          <div className="row mb-5">
            <div className="col-md-12">
              <h1 className="explore-opportunities-title">Explore Opportunities</h1>
              <p className="explore-opportunities-text">
                Explore our current openings and find where your skills and
                passion can make a real impact.
              </p>
            </div>
          </div>

          <div className="row">
            <div className="col-md-6 mb-4 mb-md-0">
              <div className="card h-100 feature-card">
                <div className="card-body d-flex flex-column justify-content-between p-4 p-md-5">
                  <div>
                    <span className="badge badge-light px-3 py-2 mb-3 feature-badge">
                      FEATURED
                    </span>
                    <h2 className="feature-title mb-4">
                      {featuredJob.title}
                    </h2>
                    <p className="feature-desc mb-4">
                      {featuredJob.description}
                    </p>
                  </div>

                  <div className="pt-4 border-top border-secondary-subtle">
                    <div className="d-flex flex-wrap gap-4 text-muted small mb-4">
                      <span className="d-flex align-items-center mr-4">
                        <i className="fa-regular fa-clock mr-2"></i> {featuredJob.type}
                      </span>
                      <span className="d-flex align-items-center mr-4">
                        <i className="fa-solid fa-location-dot mr-2"></i> {featuredJob.location}
                      </span>
                      <span className="d-flex align-items-center">
                        <i className="fa-solid fa-layer-group mr-2"></i> {featuredJob.department}
                      </span>
                    </div>
                    <a
                      href={`mailto:careers@tedekstra.com?subject=Application for ${featuredJob.title}`}
                      className="btn btn-dark w-100 py-3 rounded-pill font-weight-bold"
                    >
                      Apply Now <i className="fa-solid fa-arrow-right ml-2"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <ul className="list-group">
                {listJobs.map((job, index) => (
                  <li key={index} className="list-group-item mb-2 list-item-card">
                    <div>
                      <div className="row">
                        <div className="col-md-2 pr-0 font-weight-bold">
                          {job.id}
                        </div>
                        <div className="col-md-8 pl-0">
                          <p className="m-0 font-weight-bold">{job.type}</p>
                        </div>
                        <img
                          src="./images/right-arrow.png"
                          style={{
                            position: "absolute",
                            right: "8%",
                            top: "30%",
                          }}
                          className="img-fluid"
                          alt=""
                        />
                      </div>

                      <p className="mt-2 mb-0">
                        {job.title}
                      </p>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Posts from Our CEO - Leadership & LinkedIn Insights */}
      <CeoPosts />

      {/* Life at Tedekstra - Media Carousel Section */}
      <section className="py-5 bg-white" data-aos="fade-up">
        <div className="container">
          <div className="row mt-2 mb-4">
            <div className="col-md-12">
              <h1 className="font-weight-bold">Life at Tedekstra</h1>
            </div>
            <p className="pl-3 mb-0">
              <img
                src="./images/star.png"
                className="img-fluid mr-2"
                alt="Star"
              />
              <img src="./images/star2.png" className="img-fluid" alt="Star" />
            </p>
          </div>

          {/* Reusable Universal Media Carousel (Supports Images, Videos & Embeds) */}
          <MediaCarousel
            items={lifeAtTedekstraMedia}
            height="520px"
            showDots={true}
            showArrows={true}
            showCounter={true}
            autoPlay={true}
            autoPlayInterval={5000}
          />
        </div>
      </section>
    </>
  );
};

export default Career;
